import { React, PT, fetchApi } from '@gasbuddy/react';
import {
  Segment, Divider, Checkbox, Card,
  Dimmer, Loader, Button, Header, Message,
} from 'semantic-ui-react';
import { Auth, Nav } from '../../components';

function countOrBlank(ct) {
  return ct ? `(${ct})` : '';
}

class BaseWipeDataPage extends React.Component {
  state = { loading: true }

  componentDidMount() {
    const { match: { params: { accountId } } } = this.props;
    fetchApi({
      url: `/identity/wipe/${accountId}/summary`,
      body: {
        accountId,
      },
    }).then(({ body }) => {
      this.setState({ loading: false, body });
    }).catch((e) => {
      // eslint-disable-next-line no-console
      console.error(e);
    });
  }

  ElementBox = ({ type, label, ...rest }) => (
    <Checkbox
      onChange={(e, p) => this.check(type, p.checked)}
      defaultChecked={this.hasElements(type)}
      label={`${label} ${countOrBlank(this.elementCount(type))}`}
      {...rest}
    />
  );

  check(type, checked) {
    this.setState({
      [type]: checked,
    });
  }

  elementCount(type) {
    const { body } = this.state;
    if (body) {
      return body[type];
    }
    return false;
  }

  hasElements(type) {
    return this.elementCount(type) > 0;
  }

  render() {
    const { loading } = this.state;
    return (
      <Auth forRoles="admin.superuser">
        <Nav>
          <Dimmer.Dimmable dimmed={loading}>
            <Dimmer active={loading}>
              <Loader />
            </Dimmer>
            <Segment basic>
              <Header>
                Wipe Member Data From GasBuddy Systems
              </Header>
              <Message warning>
                This tool will permanently delete various elements of member data from
                GasBuddy systems. By definition,
                {' '}
                <b>it cannot be undone</b>
.
              </Message>
              <Card.Group stackable>
                <Card>
                  <Card.Content>
                    <Card.Header>Identity</Card.Header>
                    <Divider />
                    <Card.Description>
                      <div><this.ElementBox type="firstlast" label="First/Last Name" /></div>
                      <div><this.ElementBox type="phone" label="Phone Numbers" /></div>
                      <div><this.ElementBox type="address" label="Addresses" /></div>
                    </Card.Description>
                  </Card.Content>
                </Card>
                <Card>
                  <Card.Content>
                    <Card.Header>Payments</Card.Header>
                    <Divider />
                    <Card.Description>
                      <div><this.ElementBox type="wex" label="GasBuddy Card" /></div>
                      <div><this.ElementBox type="bank" label="Bank Account" /></div>
                      <div><this.ElementBox type="license" label="Drivers License / Birthdate" /></div>
                    </Card.Description>
                  </Card.Content>
                </Card>
              </Card.Group>
              <Button primary floated="right" onClick={this.onSave}>Wipe User Data</Button>
            </Segment>
          </Dimmer.Dimmable>
        </Nav>
      </Auth>
    );
  }
}

BaseWipeDataPage.propTypes = {
  match: PT.shape({
    params: PT.shape({
      accountId: PT.string,
    }),
  }).isRequired,
};

export const WipeDataPage = BaseWipeDataPage;
